// extracted by mini-css-extract-plugin
export default {"button":"BuyButton_button__2i-Lb","innerButton":"BuyButton_innerButton__F8KDB"};